import { render } from "./BasicAlerts.vue?vue&type=template&id=5664a764&ts=true"
import script from "./BasicAlerts.vue?vue&type=script&lang=ts"
export * from "./BasicAlerts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__